import React, { useMemo, useState } from "react";
import { procCur } from "./procHelpers";
import { procCan, procMe, procPeople } from "./procPeople";
import { partagerPageApi } from "./procApi";
import { Icon, PrIco, ProcAv } from "./ProcUi";
import { estTesteur } from "../../utils/accesTesteurs";

// Partage d'une fiche (demande d'Anthony du 29/10/2026) : lien direct vers la
// fiche, choix des destinataires, envoi par mail (backend, route
// /procedures/pages/:id/partage). Ne peuvent la recevoir que les personnes
// qui pourront l'ouvrir : accès au module (testeurs) et droit de lecture
// sur la page. Les autres sont listées à part, grisées.

export const procLienFiche = (id) => `${window.location.origin}/home/procedures?page=${encodeURIComponent(id)}`;

const ProcPartageModal = ({ db, page, users, onClose, onSent }) => {
  const lien = procLienFiche(page.id);
  const [choix, setChoix] = useState([]);
  const [q, setQ] = useState("");
  const [message, setMessage] = useState("");
  const [copie, setCopie] = useState(false);
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState(null);

  const { avecAcces, sansAcces } = useMemo(() => {
    const parId = new Map((users || []).map((u) => [String(u.id), u]));
    const me = procMe();
    const avec = [];
    const sans = [];
    procPeople()
      .filter((p) => p.id !== me)
      .forEach((p) => {
        const u = parId.get(p.id);
        (u && estTesteur(u) && procCan(db, page, "read", p.id) ? avec : sans).push(p);
      });
    return { avecAcces: avec, sansAcces: sans };
  }, [db, page, users]);

  const filtre = (l) => {
    const n = q.trim().toLowerCase();
    return n ? l.filter((p) => p.name.toLowerCase().includes(n)) : l;
  };
  const basculer = (id) => setChoix((c) => (c.includes(id) ? c.filter((x) => x !== id) : [...c, id]));

  const copier = async () => {
    try {
      await navigator.clipboard.writeText(lien);
      setCopie(true);
      setTimeout(() => setCopie(false), 2000);
    } catch (e) {
      setErreur("Copie impossible : sélectionnez le lien et copiez-le à la main.");
    }
  };

  const envoyer = async () => {
    setEnvoi(true);
    setErreur(null);
    try {
      const r = await partagerPageApi(page.id, { destinataires: choix, message, origine: window.location.origin });
      onSent(r);
    } catch (e) {
      setErreur(e.message || "L'envoi a échoué.");
      setEnvoi(false);
    }
  };

  const ligne = (p, actif) => (
    <label key={p.id} className={`pr-share-row ${actif ? "" : "is-off"}`}>
      <input type="checkbox" disabled={!actif || envoi} checked={choix.includes(p.id)} onChange={() => basculer(p.id)} />
      <ProcAv id={p.id} size={26} />
      <span className="pr-acl-name"><b>{p.name}</b>{!actif && <small>Pas d'accès à cette procédure</small>}</span>
    </label>
  );

  const avec = filtre(avecAcces);
  const sans = filtre(sansAcces);

  return (
    <div className="scrim" onClick={envoi ? undefined : onClose}>
      <div className="modal pr-acl-modal pr-share-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div className="icon-square"><PrIco n="share" s={20} /></div>
          <div>
            <h2>Partager la procédure</h2>
            <div className="meta"><span style={{ fontSize: 12.5, color: "var(--ink-3)" }}>{procCur(page).title}</span></div>
          </div>
          <div className="actions"><button className="x-btn" onClick={onClose} disabled={envoi}><Icon name="x" size={16} /></button></div>
        </div>
        <div className="modal-body pr-acl-body">
          <div>
            <label className="pr-f-lab">Lien de la fiche</label>
            <div className="pr-share-link">
              <input className="pr-f-in" readOnly value={lien} onFocus={(e) => e.target.select()} />
              <button className="btn" onClick={copier}>
                {copie ? <><Icon name="check" size={14} /> Copié</> : <><PrIco n="copy" s={14} /> Copier</>}
              </button>
            </div>
          </div>
          <div>
            <label className="pr-f-lab">Destinataires {choix.length > 0 && <span className="pr-share-n">{choix.length}</span>}</label>
            <input className="pr-f-in" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un collaborateur…" />
            <div className="pr-acl-list pr-share-list">
              {avec.map((p) => ligne(p, true))}
              {!avecAcces.length && <div className="pr-empty">Personne d'autre n'a accès à cette procédure.</div>}
              {avecAcces.length > 0 && !avec.length && <div className="pr-empty">Aucun collaborateur ne correspond.</div>}
              {sans.length > 0 && <div className="pr-share-sep">Sans accès</div>}
              {sans.map((p) => ligne(p, false))}
            </div>
          </div>
          <div>
            <label className="pr-f-lab">Message <span className="pr-share-opt">(facultatif)</span></label>
            <textarea
              className="pr-f-in pr-share-msg"
              value={message}
              maxLength={2000}
              disabled={envoi}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Ex. : Voici la procédure dont je te parlais pour la clôture."
            />
          </div>
          {erreur && <div className="pr-banner bad"><Icon name="alert" size={14} /> {erreur}</div>}
        </div>
        <div className="pr-new-foot">
          <button className="btn" onClick={onClose} disabled={envoi}>Annuler</button>
          <button className="btn primary" disabled={!choix.length || envoi} onClick={envoyer}>
            {envoi ? <><span className="pr-share-spin" /> Envoi…</> : <><PrIco n="send" s={14} /> Envoyer{choix.length > 1 ? ` (${choix.length})` : ""}</>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProcPartageModal;
